import React from 'react';

import ProductsCarousel from '../ProductsCarousel/ProductsCarousel';

const ModuleProductsCarousel = ({
  latest,
  bestSellers,
  discounted,
  selected,
  loading,
  primaryColor,
  secondaryColor,
  sliderCircleArrowsProducts,
  productsCarouselVersion,
  coloredBackgroundProducts,
  productsCarouselTitle,
  productsExplodedMobileView,
  productsThumbnail,
  isMobile,
}) => {
  return (
    <ProductsCarousel
      isMobile={isMobile}
      latest={latest}
      bestSellers={bestSellers}
      discounted={discounted}
      selected={selected}
      loading={loading}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      sliderCircleArrowsProducts={sliderCircleArrowsProducts}
      productsCarouselVersion={productsCarouselVersion}
      productsThumbnail={productsThumbnail}
      coloredBackgroundProducts={coloredBackgroundProducts}
      productsCarouselTitle={productsCarouselTitle}
      productsExplodedMobileView={productsExplodedMobileView}
    />
  );
};

export default ModuleProductsCarousel;
